// Content for Yazid M. Al-Badarin portfolio — Koyta-style layout, Yazid's real strengths.

export const PROFILE = {
  name: "Yazid M. Al-Badarin",
  first: "Yazid",
  last: "Al-Badarin",
  roleHeadline: "Shaping the Future with AI",
  roleSub: "Tech Innovator · Patent Holder · AI Educator",
  pitch: "3 patents. 5 prestigious prizes. 8 AI platforms.\nOne mission: turning research into tools that impact the world.",
  location: "Joensuu, Finland · Al-Quds, Palestine",
  email: "yazidm@yazid.me",
  emailAlt: "yazidalbadarin@gmail.com",
  whatsapp1: "+972 599 292 050",
  whatsapp2: "+972 593 101 949",
  whatsapp1Link: "https://wa.me/972599292050",
  whatsapp2Link: "https://wa.me/972593101949",
  researchgate: "https://www.researchgate.net/profile/Yazid-Albadarin?ev=hdr_xprf",
  linkedin: "https://www.linkedin.com/in/yazid-albadarin-4828212a7/",
  facebook: "https://www.facebook.com/abu.ghynaa/",
  uef: "https://sites.uef.fi/learning-analytics/members/yazid/",
  cv: "/docs/Yazid-Al-Badarin-CV.pdf",
  portraitMain: "https://customer-assets.emergentagent.com/job_yazid-innovator/artifacts/x6yikeoj_WhatsApp%20Image%202026-05-28%20at%209.34.09%20PM-modified.png",
  portraitSuit: "https://customer-assets.emergentagent.com/job_d638be74-32f2-4a09-9b9c-487a638ce382/artifacts/r0b5fq3w_1778750857131.jpg",
  candidStage: "https://customer-assets.emergentagent.com/job_yazid-innovator/artifacts/830q8sfp_image.png",
};

export const ABOUT_TITLE = "Hi there, I'm Yazid";
export const ABOUT_SUBTITLE = "Computer Science Educator · AI Researcher · Innovator — based between Finland & Palestine.";
export const ABOUT_PARAGRAPHS = [
  "I am Yazid M. Albadarin, a Computer Science educator, researcher, and AI innovator passionate about leveraging emerging technologies to improve education, creativity, and real-world problem solving. I currently serve as the Head of Computer Science at Al-Quds Bard College and I am a PhD candidate in Artificial Intelligence at the University of Eastern Finland.",
  "My work focuses on the intersection of Generative AI, programming education, critical thinking, and human-centered technology design. I conduct research exploring how AI tools such as large language models can support students in debugging, problem solving, algorithmic thinking, and programming education. My research has contributed to understanding how structured AI-assisted learning environments can enhance students' debugging skills, critical thinking abilities, and long-term retention.",
  "Beyond academia, I am deeply interested in transforming innovative ideas into impactful solutions. I have founded and contributed to multiple AI-driven educational platforms and projects aimed at empowering learners and educators with accessible and intelligent technologies. I also hold patents in smart medical technologies and actively work on interdisciplinary projects that combine AI, healthcare, education, and creativity.",
  "As an educator and workshop leader, I regularly deliver interactive sessions on Artificial Intelligence, Vibe Coding, creative thinking, emerging technologies, and innovation. My goal is to help students, educators, and professionals harness AI not only as a tool for automation, but as a catalyst for creativity, learning, and meaningful innovation.",
  "I believe technology should empower people, expand opportunities, and inspire the next generation of creators, researchers, and problem solvers.",
];

// Why-choose-me strengths (Koyta "Services" pattern, repurposed)
export const STRENGTHS = [
  {
    icon: "Award",
    title: "Patent-Holding Innovator",
    tags: ["AR Glasses (DHH)", "Smart Health Band", "Cancer Detection"],
    desc: "Three registered patents in assistive and health technology — translating research into deployable hardware that respects users.",
  },
  {
    icon: "Sparkles",
    title: "AI Platforms in Production",
    tags: ["RasheedGPT", "FaheemGPT", "Fateen"],
    desc: "Eight live AI-powered platforms serving K-12 students, Tawjihi candidates, university classrooms and genomic researchers.",
  },
  {
    icon: "GraduationCap",
    title: "Artificial Intelligence Researcher",
    tags: ["PhD UEF", "Finland", "Generative AI in Education"],
    desc: "Doctoral research at the University of Eastern Finland on how AI personalises learning across cultures and languages.",
  },
  {
    icon: "Trophy",
    title: "Mentor of World Champions",
    tags: ["Intel ISEF 1st", "Intel ISEF 2nd", "Hult Prize Jury"],
    desc: "Coached Palestinian students to first- and second-place wins at Intel ISEF — the world's largest pre-college science fair.",
  },
  {
    icon: "Building2",
    title: "Program Leadership",
    tags: ["CS Program Head", "Al-Quds Bard", "IT Manager"],
    desc: "Leading the Computer Science programme and IT infrastructure of Al-Quds Bard — strategy, hiring, supervision and accreditation.",
  },
  {
    icon: "Globe2",
    title: "Cross-Cultural Educator",
    tags: ["Arabic & English", "11 Countries", "MENA + EU"],
    desc: "Fluent bridge between Arabic and English academia — invited speaker and collaborator across Europe, the Gulf and North America.",
  },
];

// Skills progress bars (Koyta pattern)
export const SKILLS_PROGRESS = [
  { label: "Artificial Intelligence & Generative AI", percent: 95 },
  { label: "AI Research & Programming Education", percent: 92 },
  { label: "Patent Development & Innovation", percent: 95 },
  { label: "Academic Program Leadership", percent: 90 },
  { label: "AR / VR Engineering", percent: 85 },
  { label: "Public Speaking & Mentorship", percent: 92 },
];

// Hero strip animated counters
export const COUNTERS = [
  { icon: "Calendar", label: "Years of Experience", value: 14, suffix: "+" },
  { icon: "Users", label: "Students Mentored", value: 100, suffix: "+" },
  { icon: "Award", label: "Patents & Awards", value: 8, suffix: "" },
  { icon: "Globe2", label: "Countries Crossed", value: 11, suffix: "" },
];

export const PROJECTS = [
  {
    name: "RaqeebGPT",
    category: "AI Platform",
    tag: "Visual Intelligence",
    blurb: "AI-powered smart surveillance and visual intelligence platform — turning traditional cameras into intelligent systems that understand, track and analyse real-time video. Computer vision + Generative AI for semantic video search, suspicious activity detection and instant visual insights.",
    url: "https://www.raqeebgpt.com",
    image: "https://images.unsplash.com/photo-1557597774-9d273605dfa9?w=1200&q=80&auto=format&fit=crop",
    year: "2025-2026",
  },
  {
    name: "Youthriving",
    category: "AI Platform",
    tag: "Youth Empowerment",
    blurb: "AI-powered platform designed to empower Palestinian youth — helping them understand themselves, discover their strengths, identify opportunities and build a personalised path to the future. Academic, psychological, skill-based and professional support for the next generation of leaders.",
    url: "https://youthriving.site/",
    image: "https://customer-assets.emergentagent.com/job_yazid-innovator/artifacts/ny6qf7w6_image.png",
    year: "2025-2026",
  },
  {
    name: "RasheedGPT",
    category: "AI Platform",
    tag: "K-12 AI Tutor",
    blurb: "The first AI-powered educational platform in Palestine — supporting parents and elementary students through simplified lessons, story-based learning and a 24/7 AI tutor.",
    url: "https://www.rasheedgpt.com",
    image: "https://customer-assets.emergentagent.com/job_yazid-innovator/artifacts/96oxkyjk_image.png",
    year: "2025-2026",
  },
  {
    name: "Fateen",
    category: "AI Platform",
    tag: "Tawjihi Companion",
    blurb: "Complete companion for Palestinian high-school students preparing for Tawjihi — resources, past exams, scholarships, and an AI assistant that explains and quizzes them.",
    url: "https://play.google.com/store/apps/details?id=com.fateen.app",
    image: "https://images.unsplash.com/photo-1606326608606-aa0b62935f2b?w=1200&q=80&auto=format&fit=crop",
    year: "2025-2026",
  },
  {
    name: "FaheemGPT",
    category: "AI Platform",
    tag: "Higher-Ed AI",
    blurb: "An intelligent learning companion for universities. Generates summaries, worksheets, exams and concept maps; tracks each student's journey and supports instructors with analytics.",
    url: "https://www.faheemgpt.com",
    image: "https://customer-assets.emergentagent.com/job_yazid-innovator/artifacts/trbdwxkw_image.png",
    year: "2025-2026",
  },
  {
    name: "HakeemGPT",
    category: "AI Platform",
    tag: "Schedule Intelligence",
    blurb: "Decision-support system for students and institutions — analysing class schedules to find the best windows for activities, lectures and events.",
    url: "https://www.hakeemgpt.com",
    image: "https://images.unsplash.com/photo-1551434678-e076c223a692?w=1200&q=80&auto=format&fit=crop",
    year: "2025-2026",
  },
  {
    name: "PathoGenix",
    category: "Research",
    tag: "Genomics × AI",
    blurb: "Advanced platform using AI to analyse Whole Genome Sequencing for early disease detection and personalised treatment plans — supervised student innovation.",
    url: "#",
    image: "https://static.prod-images.emergentagent.com/jobs/d638be74-32f2-4a09-9b9c-487a638ce382/images/ec2f1b2ae1d6d02fc1d90eec297852f69bab0fac02c9185b298633b7e54e3c3f.png",
    year: "2025-2026",
  },
  {
    name: "AR Smart Glasses",
    category: "Patent",
    tag: "Assistive Tech",
    blurb: "AR-enabled smart glasses that translate spoken language into live captions in the wearer's field of view — for Deaf & Hard-of-Hearing individuals.",
    url: "#patents",
    image: "https://static.prod-images.emergentagent.com/jobs/d638be74-32f2-4a09-9b9c-487a638ce382/images/5af50d102969bac0fe699380792e6ec3de4c69dea134758c057a13b1b4da51f3.png",
    year: "2020",
  },
  {
    name: "Smart Temperature Band",
    category: "Patent",
    tag: "Health Tech",
    blurb: "Wearable smart band for continuous, contactless monitoring of patient body temperature — passed the Stars of Science advanced rounds.",
    url: "#patents",
    image: "https://static.prod-images.emergentagent.com/jobs/d638be74-32f2-4a09-9b9c-487a638ce382/images/2791e131fef883fb81878977ca31c40f1a3ceb51253ebc00ad4ad70ed1961862.png",
    year: "2018",
  },
  {
    name: "Breast Cancer Detection",
    category: "Patent",
    tag: "Health Tech",
    blurb: "Thermal imaging system that detects early signs of breast cancer through a smartphone application.",
    url: "#patents",
    image: "https://images.unsplash.com/photo-1631815589968-fdb09a223b1e?w=1200&q=80&auto=format&fit=crop",
    year: "2016",
  },
];

export const PROJECT_CATEGORIES = ["All", "AI Platform", "Patent", "Research"];

export const PATENTS = [
  {
    no: "346",
    year: "2020",
    title: "Augmented Reality Smart Glasses for Deaf & Hard-Hearing Individuals",
    desc: "AR-enabled smart glasses translating spoken language to live captions in the wearer's field of view.",
    issuer: "Palestine — Ministry of National Economy · Industrial Property Magazine, Issue XXIII",
    image: "https://static.prod-images.emergentagent.com/jobs/d638be74-32f2-4a09-9b9c-487a638ce382/images/5af50d102969bac0fe699380792e6ec3de4c69dea134758c057a13b1b4da51f3.png",
  },
  {
    no: "321",
    year: "2018",
    title: "Smart Temperature Band",
    desc: "Wearable smart band for continuous, contactless monitoring of patient body temperature.",
    issuer: "Palestine — Ministry of National Economy · Industrial Property Magazine, Issue XXI",
    image: "https://static.prod-images.emergentagent.com/jobs/d638be74-32f2-4a09-9b9c-487a638ce382/images/2791e131fef883fb81878977ca31c40f1a3ceb51253ebc00ad4ad70ed1961862.png",
  },
  {
    no: "275",
    year: "2016",
    title: "Breast Cancer Detection via Smartphone",
    desc: "Thermal imaging system that detects early signs of breast cancer through a smartphone application.",
    issuer: "Palestine — Ministry of National Economy · Industrial Property Magazine, Issue XVII",
    image: "https://customer-assets.emergentagent.com/job_yazid-innovator/artifacts/ssi373nj_thermaiscan-1.jpg",
  },
];

export const JOURNEY = [
  { id: "PS", name: "Palestine", code: 275, isHome: true, purpose: "Home country — born, raised, and where my work begins.", coords: [35.2, 31.9] },
  { id: "FI", name: "Finland", code: 246, purpose: "PhD studies at the University of Eastern Finland — Artificial Intelligence.", coords: [25.5, 64.5] },
  { id: "US", name: "United States", code: 840, purpose: "Bard College, NY — fellowship in Language & Thinking through Technology; Translator / Facilitator-Coach with Carey Institute for Global Good; and presented 'Thinking about Video Games: Reality and Virtuality' at Bard's 2-day arts & humanities conference.", coords: [-100, 40] },
  { id: "AE", name: "United Arab Emirates", code: 784, purpose: "Advanced Digital Marketing and Social Media Training.", coords: [54, 24] },
  { id: "SA", name: "Saudi Arabia", code: 682, purpose: "Speaking engagements on AI in education.", coords: [45, 24] },
  { id: "JO", name: "Jordan", code: 400, purpose: "Regional workshops and academic exchange.", coords: [36.5, 31.5] },
  { id: "LB", name: "Lebanon", code: 422, purpose: "Contestant — Stars of Science (Qatar Foundation).", coords: [35.8, 33.9] },
  { id: "TN", name: "Tunisia", code: 788, purpose: "Participating in the development of the International Master of Science in Cyber-Physical Systems programme.", coords: [9.5, 34] },
  { id: "OM", name: "Oman", code: 512, purpose: "Won Third Place at the 26th Arab Creative Student Forum.", coords: [56, 21] },
  { id: "CY", name: "Cyprus", code: 196, purpose: "Mediterranean research collaboration.", coords: [33, 35] },
  { id: "KG", name: "Kyrgyzstan · Bishkek", code: 417, purpose: "Built collaboration between 49 universities across the world focused on IT infrastructures.", coords: [74.6, 41.2] },
  { id: "IN", name: "India", code: 356, purpose: "Virtual and Augmented Reality Training.", coords: [78, 22] },
  { id: "NL", name: "Netherlands", code: 528, purpose: "Contributed to discussions on remote internships and delivered a presentation on leveraging AI in education and online internships.", coords: [5.3, 52.1] },
];

export const TIMELINE = [
  { when: "2024 — Present", title: "PhD Researcher, Artificial Intelligence", where: "University of Eastern Finland · Joensuu, FI", body: "Researching how AI — especially large language models — supports debugging, problem solving, algorithmic thinking and programming education across diverse classrooms." },
  { when: "2020 — Present", title: "Acting Program Head, Computer Science", where: "Al-Quds Bard College for Arts & Sciences · Abu Dis, PS", body: "Leading the Computer Science program — academic strategy, faculty supervision, and student mentorship across academic and research activities." },
  { when: "2011 — Present", title: "IT Manager", where: "Al-Quds Bard College · Al-Quds University", body: "Architecting, implementing and maintaining the college's technology infrastructure and IT team." },
  { when: "2018 — 2019", title: "Translator / Facilitator-Coach", where: "Carey Institute for Global Good · Rensselaerville, NY", body: "Built the Arabic adaptation of the 'Tawasol: Learning Coexistence' programme in partnership with Plan International Egypt." },
  { when: "2011 — 2013", title: "Master of Arts in Teaching, Mathematics", where: "Al-Quds Bard College (AQB) · 86.8%", body: "Research: 'Poisson Distribution' and a classroom study using pattern blocks to teach fractions to 5th-graders." },
  { when: "2004 — 2008", title: "B.Sc. Information Technology", where: "Al-Quds University · 80.0%", body: "Senior project: implementing Voice over IP on the Al-Quds University network." },
];

export const HONORS = [
  {
    year: "2026",
    rank: "1st Place",
    level: "National",
    title: "1st Place — PSSF Innovation Contest",
    body: "Dana Dawabsha (4th year) took first place in the Palestinian Student Scholarship Fund Innovation Contest for the BlinkVoice application — assistive communication powered by AI.",
    image: "/honors/image4.jpeg",
  },
  {
    year: "2026",
    rank: "2nd Place",
    level: "National",
    title: "2nd Place at Strength & Strive Contest (YOUthRIVING)",
    body: "Darine AlAzza, Sajeda Manasrah, Leen Najajreh and Caesar Subaih took second place at the PSSF Strength & Strive Contest with the YOUthRIVING AI-powered platform for Palestinian youth empowerment.",
    image: "/honors/image5.jpeg",
  },
  {
    year: "2025",
    rank: "1st Place",
    level: "National",
    title: "1st Place — National Innovation Competition",
    body: "Mohammad Nour and his team took first place in the national innovation competition for the project Mulhem.",
    image: "/honors/image1.jpeg",
  },
  {
    year: "2025",
    rank: "2nd Place",
    level: "Regional",
    title: "2nd Place — e-Health Hackathon",
    body: "Served as a Tech Mentor at the e-Health Hackathon organised by the Palestinian Medical Relief Society in partnership with UNFPA and Canada's international assistance — guiding the team to a 2nd-place finish.",
    image: "/honors/image2.jpeg",
  },
  {
    year: "2025",
    rank: "3rd Place",
    level: "Arab World",
    title: "3rd Place · 26th Arab Creative Student Forum (Oman)",
    body: "Shahd Abdo placed third in the Modern Trends in Information Technology category for the applied research project Waseet — The Future of Second-Hand Electronics, hosted by the University of Nizwa, Sultanate of Oman.",
    image: "/honors/image3.jpeg",
  },
  {
    year: "2026",
    rank: "Speaker",
    level: "International",
    title: "International Workshop — Vibe Coding & AI-Powered Solution Development",
    body: "Delivered an international workshop on Vibe Coding and AI-Powered Solution Development hosted by the Center for Teaching, Learning and Technology at the American University of Central Asia.",
    image: "/honors/image6.png",
  },
  {
    year: "2026",
    rank: "Speaker",
    level: "National",
    title: "Workshop — From Ideas to Global Impact (Science Museum × AQB × MoEHE × Belgian Development Agency)",
    body: "Led the workshop 'From Ideas to Global Impact: Harnessing AI to Transform Innovative Concepts into Real-World Products and Solutions,' organised with the Science Museum, AQB, the Palestinian Ministry of Education & Higher Education, and the Belgian Development Agency.",
    image: "https://customer-assets.emergentagent.com/job_yazid-innovator/artifacts/n4wdu5dm_1779282704383%20%281%29.jpg",
    imagePosition: "center 28%",
  },
  {
    year: "2025",
    rank: "Speaker",
    level: "International",
    title: "Empowering University Students with AI & 21st-Century Skills",
    body: "Delivered an interactive workshop for university students on 21st-century skills and the fundamentals of Artificial Intelligence — part of the Technology and Human Rights course in the Open Society University Network. Simplified core AI concepts, promoted responsible and ethical use of technology, and strengthened critical thinking, problem-solving and digital engagement through interactive discussions and real-world examples.",
    image: "https://customer-assets.emergentagent.com/job_yazid-innovator/artifacts/qbpo1xjc_WhatsApp%20Image%202026-05-29%20at%203.16.40%20PM.jpeg",
  },
  {
    year: "2026",
    rank: "Speaker",
    level: "School",
    title: "Creative Thinking for Young Minds Workshop",
    body: "Delivered an interactive workshop on creative thinking at Kingdom of Values School for elementary students (1st – 9th grade). The session built confidence, encouraged self-expression and teamwork, and stimulated imagination through games and activities that nurture creative problem-solving.",
    image: "https://customer-assets.emergentagent.com/job_yazid-innovator/artifacts/9z9a2w8x_WhatsApp%20Image%202026-05-29%20at%203.09.34%20PM.jpeg",
  },
  {
    year: "2026",
    rank: "Speaker",
    level: "Regional",
    title: "Workshop — Integrating AR & VR in Science Education",
    body: "Delivered a specialized workshop for school teachers from the Jerusalem suburbs on integrating Augmented Reality (AR) and Virtual Reality (VR) into science education — focusing on practical methods for enhancing classroom engagement and understanding. Participants showed strong engagement and contributed to meaningful discussions and knowledge exchange, strengthening collaboration between educators and creating a space for sharing practical, classroom-ready experiences.",
    image: "/honors/image8.jpeg",
  },
  {
    year: "2024",
    rank: "Speaker",
    level: "School",
    title: "Creative Thinking Summer Camp — Orthodox Girls School, Al-Eizariya",
    body: "Delivered a creative thinking workshop in the summer camp for 5th and 6th grade students at the Orthodox Girls School in Al-Eizariya — empowering young learners to think creatively, identify real-world problems, and transform their ideas into innovative solutions. Through interactive activities, challenges, and hands-on learning, the camp builds a generation capable of critical thinking, problem-solving, collaboration, and innovation — inspiring students to become future changemakers.",
    image: "/honors/image9.jpeg",
  },
  {
    year: "2024",
    rank: "Judge",
    level: "Regional",
    title: "Startup Mentorship — Enabled Fund Program",
    body: "Delivered coaching and mentorship sessions for university students through the Enabled Fund program, guiding them in transforming innovative ideas into potential startups and real-world solutions. Supported students in developing entrepreneurial thinking, problem-solving abilities, creativity, and business innovation skills through hands-on mentoring, idea validation, teamwork, and strategic planning.",
    image: "/honors/image10.jpeg",
  },
  {
    year: "2023",
    rank: "Speaker",
    level: "School",
    title: "Spotting Problems, Inventing Solutions — Workshop for Students",
    body: "Delivered an interactive workshop designed to train children to spot everyday frustrations and creatively transform them into innovative solutions. Through engaging activities, daily struggles like messy bedrooms and annoying chores became exciting opportunities for inventive design. By shifting their mindset from complaining to problem-solving, the kids learned to view the world through a confident, entrepreneurial lens — empowering them to become proactive changemakers who naturally see possibilities where others only see obstacles.",
    image: "/honors/image11.jpeg",
  },
  {
    year: "2023",
    rank: "Speaker",
    level: "School",
    title: "Unlocking Imagination & Creative Potential — Workshop for Students",
    body: "Delivered an interactive workshop focused on expanding children's imaginations and unlocking their natural creative potential. Through dynamic brainstorming exercises and open-ended design challenges, the kids learned to break free from conventional thinking and embrace original ideas. By nurturing their artistic confidence and curiosity, the session turned abstract thoughts into tangible, innovative projects — equipping them with the creative freedom to approach any future challenge with unique, outside-the-box solutions.",
    image: "/honors/image12.jpeg",
  },
  {
    year: "2019",
    rank: "Speaker",
    level: "National",
    title: "Student-Centered Teaching in Liberal Arts Science — AQU Faculty Workshop",
    body: "Co-delivered an interactive workshop for AQU faculty members on employing student-centered teaching within liberal arts science education. Together we guided professors through practical strategies to transform science students into critical thinkers who connect complex formulas to real-world ethical, social, and local challenges — shifting classroom dynamics using case-based learning, Socratic debates, and open-ended lab designs that embrace troubleshooting and critical inquiry. The collaborative session equipped faculty with the tools to inspire a new generation of scientific innovators and proactive changemakers.",
    image: "/honors/image13.jpeg",
  },
  {
    year: "2022",
    rank: "Judge",
    level: "National",
    title: "Judge — Mathematics Educational Tools Production Competition",
    body: "Served as a distinguished judge in the Mathematics Educational Tools Production Competition, co-organised by Al-Quds University, the Ministry of Education, and the Mathematics Museum. Rigorously evaluated a diverse range of competing projects designed to innovate math education through interactive learning tools — assessing the creativity, pedagogical value, and practical impact of each entry to identify the most effective solutions for modern classrooms, and supporting pioneering educators and students reshaping how mathematics is taught and experienced.",
    image: "/honors/image14.jpeg",
  },
  {
    year: "2022",
    rank: "Speaker",
    level: "National",
    title: "Game Design & Development — Workshop at Al-Quds Bard College",
    body: "Delivered an interactive workshop on video game design and development, exploring the core mechanics of creating engaging digital experiences. We analysed existing games to understand their structure and discussed innovative ways to integrate video games into the educational process. By connecting entertainment with pedagogy, the workshop highlighted how gaming can boost student engagement and foster critical thinking — equipping participants with practical insights to leverage game design as a powerful tool for modern, immersive learning.",
    image: "/honors/image15.jpeg",
  },
  {
    year: "2022",
    rank: "Speaker",
    level: "International",
    title: "VR/AR Workshop — Al-Quds Bard College (EHCN / OSUN)",
    body: "Delivered an interactive workshop on Virtual and Augmented Reality (VR/AR) for Al-Quds Bard College students as part of the Experimental Humanities Collaborative Network (EHCN/OSUN) project. Introduced the core concepts of VR and AR technologies, detailed their diverse fields of application, and explored methods for developing immersive games and applications — with a heavy focus on integrating these cutting-edge technologies into the educational process to create dynamic, engaging learning experiences and leverage spatial computing as a powerful tool for modern innovation.",
    image: "/honors/image16.jpeg",
  },
  {
    year: "2021",
    rank: "Innovation",
    level: "School",
    title: "Arduino Mask-Reminder Device — Al-Quds Bard College",
    body: "Developed an Arduino-based device at Al-Quds Bard College to remind visitors to wear face masks during the COVID-19 pandemic. Proposed by the college's Public Health and Safety Committee, the device automated entrance safety alerts to help curb the spread of the virus — highlighting the practical use of smart technology in delivering rapid, efficient solutions for community health and campus safety.",
    image: "/honors/image17.jpeg",
  },
  {
    year: "2019",
    rank: "Featured",
    level: "Arab World",
    title: "Contestant — Stars of Science (Qatar Foundation, MBC)",
    body: "Participated in Qatar Foundation's Stars of Science on MBC — the Arab world's leading pan-Arab innovation show. On this prestigious platform, I showcased my competitive edge in science, technology, and engineering by pitching and developing inventive ideas before an expert jury. Competing against top innovators from across the region sharpened my skills in rapid prototyping, product validation, and high-impact pitching — solidifying my role as a driven technological innovator dedicated to creating impactful, real-world solutions.",
    image: "/honors/image18.jpeg",
  },
  {
    year: "2018",
    rank: "Speaker",
    level: "National",
    title: "From Theory to Practice — Senior Projects Workshop",
    body: "Led a specialized workshop focused on transforming theoretical senior projects into practical, real-world solutions. We explored actionable methodologies for bridging academic research with market needs through rapid prototyping, feasibility testing, and user-centric design. By prioritising practical application over theory, the session gave students the strategic tools to turn abstract concepts into high-impact products — inspiring graduating students to view their final academic work as launchpads for tangible, scalable innovation.",
    image: "/honors/image19.jpeg",
  },
  {
    year: "2024",
    rank: "Judge",
    level: "National",
    title: "Mastering the Pitch & Jury Q&A — Workshop for University Students",
    body: "Led a specialized workshop on mastering the art of the pitch and handling intense jury Q&A sessions. We focused on high-impact presentation frameworks, clarifying value propositions, and maintaining confidence under pressure. Participants learned strategic techniques to anticipate tough questions, think on their feet, and defend their innovations with data — equipping the innovators with the essential communication skills needed to win over judges and secure project support.",
    image: "/honors/image20.jpeg",
  },
  {
    year: "2023",
    rank: "Speaker",
    level: "National",
    title: "Choosing Emerging Tech for Senior Projects — Faculty Workshop",
    body: "Led a specialized workshop with faculty members to strategically guide students in selecting emerging technologies for their senior projects. We focused on how mentors can help students integrate tools like AI, IoT, and advanced automation to ensure their research addresses modern industry demands. By shifting the academic focus toward cutting-edge technological applications, the session outlined ways to turn traditional final-year projects into highly functional, real-world solutions.",
    image: "/honors/image21.jpeg",
  },
  {
    year: "2023",
    rank: "Organizer",
    level: "National",
    title: "Organizer — Palestinian Undergraduate Research Conference",
    body: "Served as an organizer for the Undergraduate Research Conference in Palestine (2023), hosted at Al-Quds University in collaboration with the Deanship of Scientific Research and Al-Quds Bard College. Coordinated logistics, managed abstract submissions, and helped structure a prestigious platform for students across Palestine to showcase their scientific discoveries — bridging academic theory with rigorous research methodologies across diverse disciplines and empowering young Palestinian researchers to present their work, exchange innovative ideas, and contribute to the local scientific community.",
    image: "/honors/image22.jpeg",
  },
  {
    year: "2026",
    rank: "Judge",
    level: "International",
    title: "Judge — AI Bootcamp 2026, AUCA",
    body: "Took part as a judge evaluating student projects developed during the AI Bootcamp 2026 at the American University of Central Asia (AUCA), focused on using AI to address real-world problems. It was inspiring to see the creativity, critical thinking, and passion of students from different backgrounds and parts of the world, all working toward meaningful solutions. Even separated by distance, it felt like a moment of real connection — a reminder that impact does not stay within a small circle; over time it grows, crosses borders, and reaches young minds around the world.",
    image: "/honors/image23.jpeg",
  },
  {
    year: "2023",
    rank: "Judge",
    level: "National",
    title: "Judge — National STEM Competition (Regeneron ISEF Affiliate)",
    body: "Served as an official judge for the premier national STEM competition for school students in Palestine. In this role I evaluate innovative, student-led projects spanning robotics, engineering, and environmental sciences — assessing scientific methodologies, interviewing brilliant young Palestinian inventors, and selecting top projects to represent Palestine at the international Regeneron ISEF competition in the USA.",
    image: "/honors/image24.jpeg",
    imagePosition: "center 22%",
  },
  {
    year: "2021",
    rank: "Judge",
    level: "National",
    title: "Jury Member — Hult Prize at Al-Quds University",
    body: "Had the privilege and honor of serving as a jury member for the 2021 Hult Prize competition at Al-Quds University. In this role, I evaluated a diverse range of student projects — analysing their market viability, sustainability, and potential for social impact. It was incredibly inspiring to assess the creative solutions and entrepreneurial spirit of the students as they tackled pressing global issues.",
    image: "/honors/image25.jpeg",
  },
  {
    year: "2020",
    rank: "Judge",
    level: "National",
    title: "Jury Member — Intel ISEF National Qualifiers (MoEHE Palestine)",
    body: "Appointed by the Ministry of Education and Higher Education in Palestine to serve on the official jury panel. Evaluated and assessed scientific research and technological innovation projects developed by school students (Grades 9–11) during the local directorate-level qualifiers, and judged the national final showcase across Palestine to select and qualify the top winning projects representing Palestine at the prestigious Intel ISEF competition in the United States.",
    image: "/honors/image26.jpeg",
  },
  {
    year: "2025",
    rank: "Judge",
    level: "National",
    title: "Judge — University-Wide E-Government AI Hackathon",
    body: "Passionate about fostering innovation, I served as a Judge for the university-wide E-Government AI Hackathon. In this role, I evaluated a diverse range of student-led projects aimed at transforming public services through artificial intelligence — providing strategic feedback to the next generation of tech innovators.",
    image: "/honors/image27.jpeg",
  },
  {
    year: "2026",
    rank: "Mentor",
    level: "International",
    title: "Participating Lecturer — Exchange4All Dialogue Week (Leiden)",
    body: "The Exchange4All Dialogue Week brought together students, lecturers, and international partners from several countries to explore how remote internships and online projects can transform the future of international work-based learning. Through online dialogue sessions and in-person activities in Leiden, participants co-created new approaches for blended mobility and international teamwork. As a participating lecturer from Palestine, I supported students during the online dialogue sessions, contributed to discussions on remote internships, and delivered a presentation on how to leverage AI in education and online internships.",
    image: "/honors/image28.jpeg",
  },
];

export const INTERVIEWS = [
  {
    src: "/interviews/interview1.mp4",
    poster: "/interviews/interview1.jpg",
    outlet: "Television Interview",
    title: "Shaping the Future with AI",
  },
  {
    src: "/interviews/interview2.mp4",
    poster: "/interviews/interview2.jpg",
    outlet: "Television Interview",
    title: "AI in Education & 21st-Century Skills",
  },
  {
    src: "/interviews/interview3.mp4",
    poster: "/interviews/interview3.jpg",
    outlet: "Television Interview",
    title: "AI in Education & 21st-Century Skills",
  },
  {
    src: "/interviews/interview4.mp4",
    poster: "/interviews/interview4.jpg",
    outlet: "Television Interview",
    title: "Shaping the Future with AI",
  },
];

export const LEADERS = [
  {
    image: "/leaders/leader1.jpeg",
    name: "Dr. Amjad Barham",
    role: "Minister of Higher Education",
    org: "Palestinian Ministry of Education & Higher Education",
    body: "Recognized for driving innovation in academic technology, I was honored with an invitation to meet the Minister of Higher Education, Dr. Amjad Barham. I presented my portfolio of next-generation educational projects, discussing strategic alignments between advanced technology and national higher-education goals.",
  },
  {
    image: "/leaders/leader2.jpeg",
    name: "Dr. Laila Ghannam",
    role: "Governor of Ramallah & al-Bireh",
    org: "Ramallah & al-Bireh Governorate",
    body: "Honored to meet Dr. Laila Ghannam, Governor of Ramallah and al-Bireh, to discuss the intersection of innovation, technology, and community development — grateful for her invaluable feedback and shared vision for empowering youth through next-generation solutions.",
  },
];

export const CONTESTS = [
  { year: "2020", title: "Jury Panel Chairman — Intel ISEF Palestine", level: "National", body: "Chaired the jury for the national round of Intel ISEF — the world's largest pre-college science competition." },
  { year: "2020", title: "Judge — Hult Prize", level: "Global", body: "Evaluated startup ideas tackling the world's most pressing social challenges." },
  { year: "2019", title: "Judge — Hult Prize", level: "Global", body: "Assessed feasibility, scalability and community impact of contestant ventures." },
  { year: "2018", title: "Contestant — Stars of Science (Qatar Foundation)", level: "Pan-Arab", body: "Reached the advanced rounds of Season 11 with the Smart Temperature Band — later patented." },
  { year: "2017", title: "Mentor — Intel ISEF World 1st Place", level: "Global", body: "Mentored the team behind a wearable device controlling artificial limbs via deep neural networks — first place in the world." },
  { year: "2018", title: "Mentor — Intel ISEF World 2nd Place", level: "Global", body: "Mentored the wearable device assisting children with disabilities to swim safely." },
  { year: "2017", title: "Bard College — Global | Local Conference", level: "Academic", body: "Presented 'Thinking about Video Games: Reality and Virtuality' at Bard's 2-day arts & humanities conference." },
];

export const CERTIFICATIONS = [
  "Virtual & Augmented Reality Specialist · C-DAC India",
  "Language & Thinking through Technology · Bard IWT",
  "Cisco Certified Network Associate (CCNA)",
  "Google Certified Educator",
  "Microsoft Certified Educator (MCE)",
];

export const TESTIMONIALS = [
  { quote: "Yazid combines rare intellectual rigor with a deep commitment to his students. He is the kind of educator who carries an entire program on his shoulders — and makes it look effortless.", author: "Dr. Daniel Terris", title: "Dean, Al-Quds Bard College of Arts & Sciences" },
  { quote: "Yazid's research instinct and practical engineering sense are equally sharp. He moves seamlessly between the classroom, the lab and the patent office.", author: "Dr. Raid Zaghal", title: "Associate Professor, Computer Science · Al-Quds University" },
  { quote: "Working with Yazid means working with someone who sees students before he sees problems. His mentorship has reshaped how our young researchers think about innovation.", author: "Dr. Saeed Salah", title: "Assistant Professor, Computer Science · Al-Quds University" },
  { quote: "A trusted partner on cross-cultural curriculum design. Yazid brought rigor, warmth and impeccable bilingual fluency to a complex regional project.", author: "Dr. Sameh Hallaq", title: "Assistant Professor, Economics · Al-Quds Bard" },
  { quote: "Yazid is the rare academic who codes, ships, and teaches with equal authority. Our students learn more from a day with him than from a semester of theory.", author: "Mr. Mahmoud Khalid", title: "Assistant Dean, Biology Program · Al-Quds Bard" },
];

export const NAV_LINKS = [
  { id: "about", label: "About" },
  { id: "strengths", label: "Strengths" },
  { id: "skills", label: "Skills" },
  { id: "projects", label: "Portfolio" },
  { id: "journey", label: "Journey" },
  { id: "experience", label: "Resume" },
  { id: "contact", label: "Contact" },
];
